import { SelectField, SelectOption } from 'components/atoms/Select';
import { CarPreferencesSelectControlMui5 } from '../components';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import InputLabel from '@mui/material/InputLabel';
import debounce from 'lodash/debounce';
import { styled } from '@mui/material/styles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
    },
  },
};

const DEFAULT_OPTION_NAME = 'Vehicle Features';

// noinspection CssUnusedSymbol
const StyledOption = styled(SelectOption)`
  &.MuiMenuItem-root {
    padding: 2px 6px;
    white-space: unset;
  }
`;

// noinspection CssUnusedSymbol
const Label = styled(InputLabel)`
  &.MuiInputLabel-root {
    display: contents;
    cursor: pointer;
    white-space: unset;
  }
`;

// TODO SEARCH: adjust features to be filtered by the backend
const ALL_FEATURES = [
  '2nd Row Sunroof',
  '3rd Row Sunroof',
  'Adaptive Cruise Control',
  'Adustable Pedals',
  'All Wheel Drive',
  'Alloy Wheels',
  'Android Auto',
  'Antilock Brakes',
  'Apple CarPlay',
  'Audio Controls On Steering Wheel',
  'Auto-Dimming Side Mirrors',
  'Automatic Emergency Braking',
  'Auxiliary Input',
  'Backup Camera',
  'Bed Cover',
  'Bed Liner',
  'Blind Spot Monitor',
  'Bluetooth',
  'Brake Assist',
  'Child Safety Locks',
  'Chrome Wheels',
  'Convertible',
  'Cooled Driver Seat',
  'Cooled Passenger Seat',
  'Diesel Engine',
  'Dual Climate Control',
  'Dual Rear Wheels',
  'Fog Lights',
  'Four Wheel Drive',
  'Head-Up Display',
  'Heated Seats',
  'Heated Steering Wheel',
  'HID Headlights',
  'HomeLink',
  'Hybrid',
  'Keyless Entry',
  'Keyless Start',
  'Lane Departure Warning',
  'Leather Seats',
  'Leather Steering Wheel Trim',
  'Limited Slip Center Differential',
  'Memory Mirrors',
  'Memory Seat',
  'Natural Gas',
  'Navigation System',
  'Night Vision',
  'Panoramic Roof',
  'Parking Assist',
  'Power Door Locks',
  'Power Driver Seat',
  'Power Lift Gate',
  'Power Outlet',
  'Power Passenger Seat',
  'Power Side Mirrors',
  'Power Windows',
  'Premium Sound System',
  'Rain Sensing Front Wipers',
  'Rear Air Conditioning Controls',
  'Rear Audio Controls',
  'Rear Bucket Seats',
  'Rear Cross Traffic Alert',
  'Rear Seat Entertainment',
  'Rear Spoiler',
  'Remote Start',
  'Remote Trunk Release',
  'Roof Rack',
  'Running Boards',
  'Stability Control',
  'Sunroof/Moonroof',
  'Supercharged',
  'Side-Impact Air Bags',
  'Third Row Seating',
  'Tow Hooks',
  'Traction Control',
  'Trailer Hitch',
  'Turbocharged',
  'USB Port',
  'WIFI Hotspot',
  'Interior Accents',
];

export const FeatureFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();

  const options = ALL_FEATURES;

  const onChangeHandler = debounce((e) => {
    if (disabled) {
      return;
    }
    const val = e.target.value.filter((name) => name !== DEFAULT_OPTION_NAME);
    setFilterValue('feature', val);
  }, 50);

  return (
    <CarPreferencesSelectControlMui5 fullWidth>
      <SelectField
        variant='outlined'
        displayEmpty
        onChange={onChangeHandler}
        value={filters.feature || [DEFAULT_OPTION_NAME]}
        label='Vehicle Features'
        renderValue={(selected: Array<string>) =>
          selected.length > 1 ? selected.join(', ') : [selected]
        }
        multiple
        MenuProps={MenuProps}
      >
        {options.map((name) => (
          <StyledOption key={name.replace(/\s/g, '_')} value={name}>
            <Label>
              <Checkbox
                color='primary'
                checked={filters.feature?.includes(name)}
              />
              <ListItemText>{name}</ListItemText>
            </Label>
          </StyledOption>
        ))}
        {filters.feature && !options.length
          ? filters.feature.map((name) => (
              <StyledOption key={name.replace(/\s/g, '_')} value={name}>
                <Label>
                  <Checkbox color='primary' checked={true} />
                  <ListItemText>{name}</ListItemText>
                </Label>
              </StyledOption>
            ))
          : null}
      </SelectField>
    </CarPreferencesSelectControlMui5>
  );
};
